import { gql } from '@apollo/client'
import { User } from 'shared/models/user'

export const getUser = gql`
    query userMe {
        userMe {
            id
            firstName
            lastName
            nickname
            roles
            email
            profileImageKey
            isActive
            phone
        }
    }
`

export interface getUserQueryResults {
    userMe: User
}
